export function initDropdowns(): void {
  document.querySelectorAll('.choices__item.choices__item--choice.choices__item--selectable').forEach(element => {
    element.setAttribute('title', element.textContent?.trim() || '');
  });
}
